var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu container",
    attrs: {
      "id": "million-bit-menu"
    }
  }, [_c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n    Homepage\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/about')
      }
    }
  }, [_vm._v("\n    About\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/leaderboard')
      }
    }
  }, [_vm._v("\n    Leaderboard\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/plots')
      }
    }
  }, [_vm._v("\n    My Plots\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/list')
      }
    }
  }, [_vm._v("\n    Pixel List\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/break')
      }
    }
  }, [_vm._v("\n    Break \n\n    "), _c('svg', {
    staticClass: "bi bi-joystick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"
    }
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/drop')
      }
    }
  }, [_vm._v("\n    Drop \n\n    "), _c('svg', {
    staticClass: "bi bi-joystick",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"
    }
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/spaces')
      }
    }
  }, [_vm._v("\n    Based "), _c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })]), _vm._v(" Spaces\n  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-icon btn-block btn-lg",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/subscribe')
      }
    }
  }, [_vm._v("\n    Subscribe\n  ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c831be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 5aCA
// module chunks = 2